import { render, staticRenderFns } from "./BullDashboard.vue?vue&type=template&id=1164f4a2&scoped=true&"
import script from "./BullDashboard.vue?vue&type=script&lang=js&"
export * from "./BullDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1164f4a2",
  null
  
)

export default component.exports